import axios from "../utils/axios";

// 获取题目信息
export const getIssueList = (data) => {
  return axios.postFormData(`/user/bebTest/list`, data);
};
// 答题是否同分
export const queryIsEqualScoers = (data) => {
  return axios.post(`/user/bebTest/isEqualScoers`, data);
};
// 答题结果（报告）
export const queryAnswerAnalysislist = (data) => {
  return axios.post(`/user/bebTest/answerAnalysislist`, data);
};
// 提交试题
export const saveTest = (data) => {
  return axios.postFormData(`/user/bebTest/save`, data);
};

// 答题同分集合
export const queryEqualScoreslist = (data) => {
  return axios.post(`/user/bebTest/equalScoreslist`, data);
};
// 他评人列表
export const queryOtherUserRoleScoresList = (data) => {
  return axios.post(`/user/bebTest/findOtherUserRoleScoreslist`, data);
};
// 答题概况 上部
export const queryRoleScoresList = (data) => {
  return axios.post(`/user/bebTest/roleScoreslist`, data);
};
// 答题结果
export const queryTestHistoryList = (data) => {
  return axios.post(`/user/bebTest/questionsOptionHistoryList`, data);
};
// 更新角色
export const updateRoleType = (data) => {
  return axios.postFormData(`/user/bebTest/updateRoleType`, data);
};
// 答题历史记录
export const findTestHistoryList = (data) => {
  return axios.post(`/user/bebTest/findTestHistoryList`, data);
};

// 获取贝尔宾组成员列表的角色
export const joinTeam = (data) => {
  return axios.post(`/user/bebTest/joinTeam`, data);
};

// 获取贝尔宾个人测试权限
export const isHavingMyselfBebService = (data) => {
  return axios.post(`/user/common/user/isHavingMyselfBebService`, data);
};

// 获取贝尔宾首页下拉框
export const findServiceExampleList = (data) => {
  return axios.post(`/user/bebTest/findServiceExampleList`, data);
};
// 获取贝尔宾组成员列表的角色
export const findTeamUserScoresList = (data) => {
  return axios.post(`/user/bebTest/findTeamUserScoresList`, data);
};
// 获取贝尔宾组列表
export const findUserTeamList = (data) => {
  return axios.post(`/user/bebTest/findUserTeamList`, data);
};
// 登录
export const Login = (data) => {
  return axios.postOld(`/login.do`, data);
};
// 获取url参数
export const getScenegetScene = (data) => {
  return axios.post(`/user/common/wechat/getScene`, data);
};
// 获取用户信息
export const queryUserInfoById = (data) => {
  return axios.get(`/user/userInfo/queryUserInfoById`, data);
};
// 领取贝尔宾他评
export const receiveOther = (data) => {
  return axios.post(`/user/bebTest/receiveOther`, data);
};
// 获取贝尔宾他评题目列表
export const findOtherQuestionsOptionList = (data) => {
  return axios.post(`/user/bebTest/findOtherQuestionsOptionList`, data);
};

// 是否领取贝尔宾他评
export const isReceiveOther = (data) => {
  return axios.post(`/user/bebTest/isReceiveOther`, data);
};
// 是否已完成贝尔宾他评
export const isOverOther = (data) => {
  return axios.post(`/user/bebTest/isOverOther`, data);
};
// 他评均值
export const queryOtherAvgScores = (data) => {
  return axios.post(`/user/bebTest/findOtherAvgScores`, data);
};
// 获取用户信息
export const getUserInfo = (data) => {
  return axios.get(`/user/userInfo/get`, data);
};
// 获取贝尔宾组名称信息
export const findTeamByCode = (data) => {
  return axios.post(`/user/bebTest/findTeamByCode`, data);
};
// 获取贝尔宾领取次数
export const findRecordOtherResultCount = (data) => {
  return axios.get(`/user/bebTest/findRecordOtherResultCount`, data);
};
// 判断服务是否都已经完成
export const isBundleCompleted = (data) => {
  return axios.postFormData(`/user/serviceBundleUser/isBundleCompleted`, data);
};
